import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Layout from 'components/Layout/Layout'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import { getLegalDocsServer, getLegalDocsVersion } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import { useRouter } from 'next/router'

const DevicePrivacyPolicyKoPage = ({ legalDocsResponse, legalDocsVersions }) => {
  const router = useRouter()
  return (
    <Layout>
      <Container>
        <Row>
          <Col sm={12}>
            <LegalDocs
              title={legalDocsResponse.data.title}
              agreements={legalDocsResponse.data}
              legalVersions={legalDocsVersions.data[0].versions}
              initialVersion={router?.query?.v || null}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps() {
  const legalType = 'device-privacy-policy-korea_ko'
  const legalDocsResponse = await getLegalDocsServer([legalType])
  const legalDocsVersions = await getLegalDocsVersion(legalType)
  if (legalDocsResponse.statusCode === 200 && legalDocsVersions.statusCode === 200) {
    return {
      props: { legalDocsResponse, legalDocsVersions }
    }
  }
  // Not a supported local static or dynamic, or getLegalDocsServer error
  return {
    redirect: {
      destination: '/en/404',
      permanent: false
    }
  }
}

export default DevicePrivacyPolicyKoPage
